import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../store/auth';

export default function ChangePassword() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ current:'', next:'', confirm:'' });
  const [err, setErr] = useState('');
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);
  const forced = user?.mustChangePassword;

  async function submit(e) {
    e.preventDefault(); setErr('');
    if (form.next.length < 12) return setErr('12 caractères minimum.');
    if (form.next !== form.confirm) return setErr('La confirmation ne correspond pas.');
    setLoading(true);
    try {
      await api.post('/auth/change-password', { currentPassword: form.current, newPassword: form.next });
      login({ ...user, mustChangePassword: false });
      setOk(true);
      setTimeout(() => nav('/', { replace: true }), 1200);
    } catch (e) {
      setErr(e.response?.data?.error || 'Erreur');
    } finally { setLoading(false); }
  }

  return (
    <div style={st.page}>
      <div style={st.card}>
        <h2 style={st.title}>{forced ? 'Première connexion' : 'Changer le mot de passe'}</h2>
        {forced && <p style={st.info}>Pour sécuriser votre compte, choisissez un nouveau mot de passe personnel.</p>}
        {ok ? <p style={{ color:'#2E7D32', fontWeight:700, textAlign:'center' }}>✓ Mot de passe modifié</p> : (
          <form onSubmit={submit} style={{ display:'flex', flexDirection:'column', gap:10 }}>
            <input style={st.input} type="password" placeholder="Mot de passe actuel" required
              value={form.current} onChange={e=>setForm(f=>({...f,current:e.target.value}))}/>
            <input style={st.input} type="password" placeholder="Nouveau mot de passe (12 car. min)" required
              value={form.next} onChange={e=>setForm(f=>({...f,next:e.target.value}))}/>
            <input style={st.input} type="password" placeholder="Confirmer" required
              value={form.confirm} onChange={e=>setForm(f=>({...f,confirm:e.target.value}))}/>
            {err && <p style={{ color:'#C62828', fontSize:13 }}>{err}</p>}
            <button style={st.btn} disabled={loading}>{loading ? '…' : 'Valider'}</button>
          </form>
        )}
      </div>
    </div>
  );
}
const st = {
  page:{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
         background:'linear-gradient(135deg,#1E3A6E 0%,#2E75B6 100%)', padding:16 },
  card:{ background:'#fff', borderRadius:16, padding:28, width:'100%', maxWidth:400,
         boxShadow:'0 8px 32px rgba(0,0,0,.2)' },
  title:{ fontSize:18, fontWeight:800, color:'#1E3A6E', textAlign:'center', marginBottom:8 },
  info:{ fontSize:13, color:'#666', textAlign:'center', marginBottom:14 },
  input:{ width:'100%', border:'1.5px solid #e0e0e0', borderRadius:8, padding:'11px 12px', fontSize:15 },
  btn:{ background:'#1E3A6E', color:'#fff', borderRadius:10, padding:'12px', fontSize:15,
        fontWeight:700, border:'none', cursor:'pointer', marginTop:4 },
};
